import { createContext, useContext, useState, useCallback } from "react";

const QuoteContext = createContext(null);

export const QuoteProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [presetService, setPresetService] = useState(null);

  const openQuote = useCallback((service = null) => {
    setPresetService(service);
    setOpen(true);
  }, []);

  return (
    <QuoteContext.Provider value={{ open, setOpen, openQuote, presetService }}>
      {children}
    </QuoteContext.Provider>
  );
};

export const useQuote = () => {
  const ctx = useContext(QuoteContext);
  if (!ctx) throw new Error("useQuote must be used within QuoteProvider");
  return ctx;
};
